import Layout from '@/layout/index.vue'

export const LicitatieAchizitieRoute = {
  path: '/licitatie-achizitie',
  component: Layout,
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "licitatie-achizitie" */
          '@/features/licitatie-achizitie/views/index.vue'),
      name: 'LicitatieAchizitieIndexRoute',
      meta: {
        title: 'LicitatieAchizitieIndexRouteTitle',
        requiresAuth: true
      }
    },
    {
      path: 'reports',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "licitatie-achizitie" */
          '@/features/licitatie-achizitie/views/reports.vue'),
      name: 'LicitatieAchizitieReportsRoute',
      meta: {
        title: 'Rapoarte sintetice',
        requiresAuth: true
      }
    },
    {
      path: 'create',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "licitatie-achizitie-create" */
          '@/features/licitatie-achizitie/views/create-update-licitatie.vue'),
      name: 'LicitatieAchizitieCreateRoute',
      meta: {
        title: 'LicitatieAchizitieCreateRouteTitle',
        requiresAuth: true,
        action: 'create'
      }
    },
    {
      path: 'update/:licitatieAchizitieID',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "licitatie-achizitie-update" */
          '@/features/licitatie-achizitie/views/create-update-licitatie.vue'),
      name: 'LicitatieAchizitieUpdateRoute',
      meta: {
        title: 'LicitatieAchizitieUpdateRouteTitle',
        requiresAuth: true,
        action: 'update'
      }
    },
    {
      path: 'view/:licitatieAchizitieID',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "licitatie-achizitie-details" */
          '@/features/licitatie-achizitie/views/details.vue'),
      name: 'LicitatieAchizitieDetailsRoute',
      meta: {
        title: 'LicitatieAchizitieDetailsRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
